import React, { useState } from "react";
import { Button, Icon, Confirm, Popup } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { PaymentCategory } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { PaymentCategoryForm } from "../PaymentCategoryForm";
import { PaymentConceptForm } from "../PaymentConceptForm";
import "./PaymentCategoryItem.scss";

const paymentCategoryController = new PaymentCategory();

export function PaymentCategoryItem(props) {
  const { paymentCategory, onReload } = props;
  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [showModalPaymentConcept, setShowModalPaymentConcept] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isDeleted, setIsDeleted] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseModalPaymentConcept = () =>
    setShowModalPaymentConcept((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openPaymentConceptManagement = () => {
    setTitleModal(`Gestionar conceptos de pago de: ${paymentCategory.name}`);
    onOpenCloseModalPaymentConcept();
  };

  const openUpdatePaymentCategory = () => {
    setTitleModal(`Actualizar categoría de pago: ${paymentCategory.name}`);
    onOpenCloseModal();
  };

  const openDesactivateActiveConfirm = () => {
    setIsDeleted(false);
    setConfirmMessage(
      paymentCategory.status
        ? `¿Desactivar la categoría de pago ${paymentCategory.name}?`
        : `¿Activar la categoría de pago ${paymentCategory.name}?`
    );
    onOpenCloseConfirm();
  };

  const onActivateDesactivate = async () => {
    try {
      await paymentCategoryController.updatePaymentCategory(
        accessToken,
        paymentCategory.id,
        {
          status: !paymentCategory.status,
        }
      );
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const openDeleteConfirm = () => {
    setIsDeleted(true);
    setConfirmMessage(
      `¿Eliminar la categoría de pago ${paymentCategory.name}?`
    );
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await paymentCategoryController.deletePaymentCategory(
        accessToken,
        paymentCategory.id
      );
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="payment_category-item">
        <div className="payment_category-item__info">
          <span className="payment_category-item__info-title">
            {paymentCategory.name}
          </span>
        </div>
        <div>
          <Popup
            content="Gestionar conceptos de pago"
            trigger={
              <Button icon color="green" onClick={openPaymentConceptManagement}>
                <Icon name="dollar" />
              </Button>
            }
          />
          <Popup
            content="Actualizar categoría de pago"
            trigger={
              <Button icon primary onClick={openUpdatePaymentCategory}>
                <Icon name="pencil" />
              </Button>
            }
          />
          <Popup
            content={`${
              paymentCategory.status ? "Desactivar" : "Activar"
            } categoría de pago`}
            trigger={
              <Button
                icon
                color={paymentCategory.status ? "orange" : "teal"}
                onClick={openDesactivateActiveConfirm}
              >
                <Icon name={paymentCategory.status ? "ban" : "check"} />
              </Button>
            }
          />
          <Popup
            content="Eliminar categoría de pago"
            trigger={
              <Button icon color="red" onClick={openDeleteConfirm}>
                <Icon name="trash" />
              </Button>
            }
          />
        </div>
      </div>
      <BasicModal
        size="small"
        show={showModalPaymentConcept}
        close={onOpenCloseModalPaymentConcept}
        title={titleModal}
      >
        <PaymentConceptForm
          onClose={onOpenCloseModalPaymentConcept}
          onReload={onReload}
          paymentCategory={paymentCategory}
        />
      </BasicModal>
      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <PaymentCategoryForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          paymentCategory={paymentCategory}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={isDeleted ? onDelete : onActivateDesactivate}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
